import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import ProductList from './ProductList';
import CategoryList from '../categories/CategoryList';
import Modifiers from '../modifiers/Modifiers';
import ProductionList from './ProductionList';
import VariantList from './VariantList';
import { useFeatures } from '../../hooks/useFeatures';

const ACCENT = '#2e9f86';

export default function Products() {
  const { t } = useTranslation();
  const features = useFeatures();
  const [tab, setTab] = useState('products');

  const tabs = [
    { key: 'products',   label: t('products', 'Products') },
    { key: 'categories', label: t('categories', 'Categories') },
    ...(features.variants !== false ? [{ key: 'variants', label: '🎛️ Variants' }] : []),
    ...(features.add_ons ? [{ key: 'addons', label: t('addOns', 'Add-ons') }] : []),
    ...(features.production ? [{ key: 'production', label: '🏭 Production' }] : []),
  ];

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%', minHeight: 0, fontFamily: "'DM Sans', 'Segoe UI', sans-serif" }}>

      {/* ── Tab bar ── */}
      <div style={{ display: 'flex', alignItems: 'flex-end', gap: 4, padding: '0 20px', borderBottom: '1.5px solid #f0f0f0', background: '#fff', flexShrink: 0 }}>
        {tabs.map((tb) => {
          const active = tab === tb.key;
          return (
            <button key={tb.key} onClick={() => setTab(tb.key)} style={{
              position: 'relative', background: 'none', border: 'none', cursor: 'pointer',
              padding: '14px 16px 12px', fontSize: 14,
              fontWeight: active ? 700 : 500,
              color: active ? ACCENT : '#6b7280',
              borderBottom: active ? `2.5px solid ${ACCENT}` : '2.5px solid transparent',
              marginBottom: -1.5, transition: 'color 0.15s',
            }}>
              {tb.label}
            </button>
          );
        })}
      </div>

      {/* ── Tab content ── */}
      <div style={{ flex: 1, minHeight: 0, position: 'relative' }}>
        {tab === 'products' ? (
          <div style={{ height: '100%' }}>
            <ProductList />
          </div>
        ) : tab === 'categories' ? (
          <div style={{ height: '100%', overflow: 'auto', padding: 24, background: '#f8f9fa' }}>
            <CategoryList />
          </div>
        ) : tab === 'variants' ? (
          <div style={{ height: '100%', overflow: 'auto', padding: 24, background: '#f8f9fa' }}>
            <VariantList />
          </div>
        ) : tab === 'production' ? (
          <div style={{ height: '100%', overflow: 'auto', padding: 24, background: '#f8f9fa' }}>
            <ProductionList />
          </div>
        ) : (
          <div style={{ height: '100%', overflow: 'auto', padding: 24, background: '#f8f9fa' }}>
            <Modifiers />
          </div>
        )}
      </div>
    </div>
  );
}
